var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-5"},[_c('b-col',[_c('b-card',{staticClass:"text-center eor-title",attrs:{"title":_vm.header}},[(_vm.showMaturityDate)?_c('div',[_vm._v("\n        Maturity Date: "+_vm._s(_vm._f("date")(_vm.loan.maturity_date))+"\n      ")]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cef2f11","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_deals/actions/ActionModalWizardHeader.vue
// module id = null
// module chunks = 